import { Loading } from "@/components/ui/loading";
import { TourDetailsRoute } from "@/modules/tours/routes/tour-details.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tours/$tourId/")({
	component: TourDetailsRoute,
	pendingComponent: Loading,
});
